module.exports = __webpack_public_path__ + "static/media/FlyBirdsBox_RoseGold_Icons-facebook.5f7d0f32.png";